export const fontTypes = [
  {key: 0, value: 'Dotum', label: '돋움'},
  {key: 1, value: 'Gulim', label: '굴림'},
  {key: 2, value: 'Malgun Gothic', label: '맑은고딕'},
  {key: 3, value: 'Batang', label: '바탕'},
  {key: 4, value: 'New Gulim', label: '새굴림'},
  {key: 5, value: '궁서체', label: '궁서체'}
]